<template>
    <div class="ui small search fluid multiple selection dropdown" :style="{'z-index': showSuggestions ? 1 : 0}" @click="$refs.input.focus()">
        <input ref="input" class="fluid search" type="text" :value="value" @input="inputText" @change="changeText" @blur="setShowSuggestions(false)" @focus="setShowSuggestions(true)">
        <span class="ui label" v-for="tag in tags" :key="tag">
           {{ tag }}
        </span>
        <span v-if="isBreak" class="ui break label">
           <i class="ui pause icon"></i>
        </span>
        <div class="ui vertical hover menu" :style="{display: showSuggestions ? 'block' : 'none'}">
         <a class="item" v-for="option in filteredSuggestions" :key="option" @mousedown.prevent="inputText(option); setShowSuggestions(false);">
            {{ option }}
         </a>
         <div v-if="filteredSuggestions.length == 0" class="disabled item">Keine Vorschläge</div>
        </div>
    </div>
</template>

<script>

    import Fuse from 'fuse.js';

    export default {
        name: 'TopicInput',
        props: ['value', 'tags', 'isBreak', 'suggestions'],
        data: function () {
            return {
                showSuggestions: false
            }
        },
        computed: {
            splittedSuggestions: function () {
              let splittedSuggestions = [];
              let positions = [];
              for (let i = 0; i < this.suggestions.length; i++) {
                let currentSuggestion = this.suggestions[i];
                if (currentSuggestion !== this.value) {
                  while (currentSuggestion.length > 45) {
                    const lastSpace = this.getLastSpace(currentSuggestion.substring(0, 45));
                    splittedSuggestions.push(currentSuggestion.substring(0, lastSpace));
                    positions.push(i);
                    currentSuggestion = currentSuggestion.substring(lastSpace);
                  }
                  splittedSuggestions.push(currentSuggestion);
                  positions.push(i);
                }
              }
              return {
                suggestions: splittedSuggestions,
                positions: positions
              };
            },
            filteredSuggestions: function() {

                if(!this.value) {
                    return this.suggestions.slice(0).sort((a,b) => { return a.toLowerCase() > b.toLowerCase();});
                } else {

                    let maxSearchLength = 100;
                    let result = [];

                    //https://github.com/krisk/Fuse/issues/269
                    if(this.value.length <= maxSearchLength) {

                        let options = {
                            shouldSort: true,
                            includeScore: true,
                            threshold: 0.4,
                            location: 0,
                            distance: 100,
                            //maxPatternLength: maxSearchLength,
                            minMatchCharLength: 0,
                            keys: []
                        };
                        let fuse = new Fuse(this.splittedSuggestions.suggestions, options); // "list" is the item array
                        let fuseResults = fuse.search(this.value);

                        for (let fuseResult of fuseResults) {
                            if (fuseResult.score >= 0) { // no exact match
                                if (!result.includes(this.suggestions[this.splittedSuggestions.positions[fuseResult.refIndex]])) {
                                  result.push(this.suggestions[this.splittedSuggestions.positions[fuseResult.refIndex]]);
                                }
                            }
                        }
                    }

                    return result;
                }
            }
        },
        mounted () {
            if (!this.value) {
                setTimeout(() => this.$refs.input.focus(), 100);
            }
        },
        methods: {
            getLastSpace: function (text) {
              const textArray = text.split('');
              for (let i = textArray.length - 1; i >= 0; i--) {
                if (textArray[i] === ' ') return i;
              }
              return textArray.length - 1;
            },
            setShowSuggestions: function(value) {
                this.showSuggestions = !!value;
            },
            inputText: function(value) {
                this.$emit('input', typeof value === "string" ? value : value.target.value);
                this.changeText();
            },
            changeText: function () {
                this.$emit('topicChange');
            }
        }
    }
</script>

<style scoped>
   .dropdown {
      display: flex !important;
      flex-direction: row;
      flex-wrap: wrap;
      padding: .22619048em .35714286em !important;
   }
   .dropdown > input {
      min-width: 0 !important;
      width: auto !important;
      flex: 1 0 auto;
      margin-right: 3px !important;
   }
   .dropdown > .menu {
      max-height: 200px !important;
   }
   .dropdown > * {
      flex: 0 1 auto;
   }
   .break.label .icon {
      margin: 0;
   }
</style>
